var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccUnload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Card_unload",
    "data-name": "Card unload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7554",
    "data-name": "Rectangle 7554",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30360",
    "data-name": "Group 30360",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33406",
    "data-name": "Path 33406",
    d: "M22.467,12.4l-2.3.777A8.183,8.183,0,0,1,11.977,20.8a8.313,8.313,0,0,1-8.3-7.621L1.487,12.4c-.139.06,0,1.345,0,1.365a10.471,10.471,0,0,0,10.49,9.374h.03a10.6,10.6,0,0,0,10.46-9.374,6.252,6.252,0,0,0,0-1.365",
    transform: "translate(2.041 1.997)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33407",
    "data-name": "Path 33407",
    d: "M17.157,7.164H13.173v9.155H10.832V7.164H6.847L10.832,2.2,11.888.888l.09-.09.09.09,1.106,1.365Z",
    transform: "translate(2.02 2.041)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33408",
    "data-name": "Path 33408",
    d: "M12.117.907,12.012.8l-.105.1.105-.128Z",
    transform: "translate(1.984 0.13)",
    fill: "#b1bed5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccUnload);
export default __webpack_public_path__ + "static/media/mcc_unload.72f67830be9dbd6a0df58e9c399fddd5.svg";
export { ForwardRef as ReactComponent };